import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { translate } from "lib";
import { alertStore } from "stores";

const downloadPDF = async (fileName: string, blob: Blob): Promise<void> => {
  const platform = Capacitor.getPlatform();

  if (platform === "android" || platform === "ios") {
    const reader = new FileReader();

    reader.onloadend = async (): Promise<void> => {
      const base64Data = reader.result?.toString().split(",")[1];

      if (!base64Data) {
        return alertStore.show(translate("ERROR_GENERATING_FILE"), "error");
      }

      await Filesystem.writeFile({
        path: `/${fileName}`,
        data: base64Data,
        directory: Directory.Documents,
        recursive: true
      });

      alertStore.show(translate("PDF_DOWNLOADED"));
    };

    reader.readAsDataURL(blob);
  } else {
    const a = document.createElement("a");

    a.href = window.URL.createObjectURL(blob);
    a.download = fileName;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
  }
};

export { downloadPDF };
